export default "__VITE_ASSET__1cd2a175__"